import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { userSlice } from "../slices/User";
import { loginManagement } from "../hooks/api/LoginManagement";
import { locationsManagement } from "../hooks/api/LocationsManagement";
import { calendarManagement } from "../hooks/api/CalendarManagement";
import { languagesManagement } from "../hooks/api/LanguagesManagement";
import { languageProgramsManagement } from "../hooks/api/LanguageProgramsManagement";
import { notificationSlice } from "../slices/NotificationSlice";
import { employeeRolesManagement } from "../hooks/api/EmployeeRolesManagement";
import { employeesManagement } from "../hooks/api/EmployeesManagement";
import { studentSchoolsManagement } from "../hooks/api/StudentSchoolsManagement";
import { studentCertificatesManagement } from "../hooks/api/StudentCertificatesManagement/StudentCertificatesManagement";
import { noteTypesManagement } from "../hooks/api/NoteTypesManagement";
import { guardianTypesManagement } from "../hooks/api/GuardianTypesManagement";
import { meetingManagement } from "../hooks/api/MeetingManagement";
import { plansManagement } from "../hooks/api/PlansManagement";
import { monthlyReportsManagement } from "../hooks/api/MonthlyReportsManagement";
import { semiyearlyReportsManagement } from "../hooks/api/SemiyearlyReportsManagement";
import { yearlyReportsManagement } from "../hooks/api/YearlyReportsManagement";
import { calendarHolidaysManagement } from "../hooks/api/CalendarHolidaysManagement";
import { studentsManagement } from "../hooks/api/StudentsManagement";
import { groupsManagement } from "../hooks/api/GroupsManagement";
import { guardiansManagement } from "../hooks/api/GuardiansManagement";
import { municipalitiesManagement } from "../hooks/api/MunicipalitiesManagement/MunicipalitiesManagement";
import { notificationsManagement } from "../hooks/api/NotificationsManagement/NotificationsManagement";
import { groupTypesManagement } from "../hooks/api/GroupTypesManagement";
import { groupProgressManagement } from "../hooks/api/GroupProgressManagement";
import { groupProgressTestsManagement } from "../hooks/api/GroupProgressTestsManagement";
import { reportTypesManagement } from "../hooks/api/ReportTypesManagement/ReportTypesManagement";
import { legalEntityManagement } from "../hooks/api/LegalEntitiesManagement/LegalEntitiesManagement";
import { userManagement } from "../hooks/api/UserManagement";
import { employeeWeeklyReportManagement } from "../hooks/api/EmployeeWeeklyReportManagement";
import { settingsCallManagement } from "../hooks/api/SettingsCallManagement";
import { callsManagement } from "../hooks/api/CallsManagement";
import { studentAddressManagement } from "../hooks/api/StudentAddressManagement";
import { dashboardManagement } from "../hooks/api/DashboardManagement";
import { studentGuardianManagement } from "../hooks/api/StudentGuardianManagement";


export const store = configureStore({
    reducer: {
        [userSlice.name]: userSlice.reducer,
        [notificationSlice.name]: notificationSlice.reducer,
        [dashboardManagement.reducerPath]:dashboardManagement.reducer,
        [loginManagement.reducerPath]: loginManagement.reducer,
        [locationsManagement.reducerPath]: loginManagement.reducer,
        [legalEntityManagement.reducerPath]: legalEntityManagement.reducer,
        [languagesManagement.reducerPath]: loginManagement.reducer,
        [calendarManagement.reducerPath]: calendarManagement.reducer,
        [languageProgramsManagement.reducerPath]: loginManagement.reducer,
        [employeeRolesManagement.reducerPath]: employeeRolesManagement.reducer,
        [employeesManagement.reducerPath]: employeesManagement.reducer,
        [studentGuardianManagement.reducerPath]: studentGuardianManagement.reducer,
        [employeeWeeklyReportManagement.reducerPath]: employeeWeeklyReportManagement.reducer,
        [studentSchoolsManagement.reducerPath]: studentSchoolsManagement.reducer,
        [studentCertificatesManagement.reducerPath]: studentCertificatesManagement.reducer,
        [studentAddressManagement.reducerPath]: studentAddressManagement.reducer,
        [noteTypesManagement.reducerPath]: noteTypesManagement.reducer,
        [groupTypesManagement.reducerPath]: groupTypesManagement.reducer,
        [reportTypesManagement.reducerPath]: reportTypesManagement.reducer,
        [groupProgressManagement.reducerPath]: groupProgressManagement.reducer,
        [groupProgressTestsManagement.reducerPath]: groupProgressTestsManagement.reducer,
        [guardianTypesManagement.reducerPath]: guardianTypesManagement.reducer,
        [municipalitiesManagement.reducerPath]: municipalitiesManagement.reducer,
        [meetingManagement.reducerPath]: meetingManagement.reducer,
        [plansManagement.reducerPath]: plansManagement.reducer,
        [monthlyReportsManagement.reducerPath]: monthlyReportsManagement.reducer,
        [semiyearlyReportsManagement.reducerPath]: semiyearlyReportsManagement.reducer,
        [yearlyReportsManagement.reducerPath]: yearlyReportsManagement.reducer,
        [userManagement.reducerPath]: userManagement.reducer,
        [calendarHolidaysManagement.reducerPath]: calendarHolidaysManagement.reducer,
        [studentsManagement.reducerPath]: studentsManagement.reducer,
        [callsManagement.reducerPath]: callsManagement.reducer,
        [groupsManagement.reducerPath]: groupsManagement.reducer,
        [guardiansManagement.reducerPath]:guardiansManagement.reducer,
        [notificationsManagement.reducerPath]:notificationsManagement.reducer,
        [settingsCallManagement.reducerPath]:settingsCallManagement.reducer
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: ["notification/showNotification"],
                ignoredPaths: ["notification.onConfirm"],
            },
        })
            .concat(loginManagement.middleware)
            .concat(dashboardManagement.middleware)
            .concat(calendarManagement.middleware)
            .concat(locationsManagement.middleware)
            .concat(legalEntityManagement.middleware)
            .concat(languagesManagement.middleware)
            .concat(languageProgramsManagement.middleware)
            .concat(employeeRolesManagement.middleware)
            .concat(employeesManagement.middleware)
            .concat(studentGuardianManagement.middleware)
            .concat(employeeWeeklyReportManagement.middleware)
            .concat(studentSchoolsManagement.middleware)
            .concat(studentCertificatesManagement.middleware)
            .concat(studentAddressManagement.middleware)
            .concat(noteTypesManagement.middleware)
            .concat(groupTypesManagement.middleware)
            .concat(reportTypesManagement.middleware)
            .concat(groupProgressManagement.middleware)
            .concat(groupProgressTestsManagement.middleware)
            .concat(guardianTypesManagement.middleware)
            .concat(municipalitiesManagement.middleware)
            .concat(meetingManagement.middleware)
            .concat(plansManagement.middleware)
            .concat(monthlyReportsManagement.middleware)
            .concat(semiyearlyReportsManagement.middleware)
            .concat(yearlyReportsManagement.middleware)
            .concat(userManagement.middleware)
            .concat(calendarHolidaysManagement.middleware)
            .concat(studentsManagement.middleware)
            .concat(callsManagement.middleware)
            .concat(groupsManagement.middleware)
            .concat(guardiansManagement.middleware)
            .concat(notificationsManagement.middleware)
            .concat(settingsCallManagement.middleware),
});

setupListeners(store.dispatch);
